// src/index.jsx (або ваш entrypoint)
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initAuthForceLoginOnLoad } from './auth';

// прибираємо токен ще до рендеру — завжди буде редірект на /login
initAuthForceLoginOnLoad();

const root = createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
